module.exports = __webpack_public_path__ + "so.b105ba8737b418a7e14c.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/so.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/so.svg
// module chunks = styles